// extracted by mini-css-extract-plugin
export default {"gridFooter":"PageBreak_gridFooter__XjZxU","orBreak":"PageBreak_orBreak__i7cCg"};